import { render, staticRenderFns } from "./pd-le-blurb.vue?vue&type=template&id=bc3588ea&scoped=true&"
import script from "./pd-le-blurb.vue?vue&type=script&lang=js&"
export * from "./pd-le-blurb.vue?vue&type=script&lang=js&"
import style0 from "./pd-le-blurb.vue?vue&type=style&index=0&id=bc3588ea&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3588ea",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OutlineButton: require('/opt/build/repo/storefront/components/atoms/Button/OutlineButton.vue').default})
